import React from 'react'
import { PractitionerRole } from '@teschglobal/tg-fhir-react-components'
import type { PractitionerRole as FHIRPractitionerRole } 
  from '@teschglobal/tg-fhir-react-components/dist/types'
import useFhirConfig from '../../../../../hooks/admin/useFhirConfig'
import FhirLoader from '../../../../FhirLoader'

type PractitionerRoleDetailProps = {
  resource: FHIRPractitionerRole | null
   isFetching: boolean
}

const PractitionerRoleDetail: React.FC<PractitionerRoleDetailProps> = ({ resource, isFetching}) => {
    if (isFetching) return <FhirLoader />
    if (!resource) {
    return (
      <div className="text-center" role="status" aria-live="polite">
        Not Found
      </div>
    )
  }
  

  const {
    providerDirectoryFhirConfig,
    handleSelectOrganization,
    handleSelectLocation,
    handleSelectPractitioner
  } = useFhirConfig()

  return (
    <section>
      <h3>PractitionerRole</h3>
      <PractitionerRole
        data={resource}
        fhirApiConfig={providerDirectoryFhirConfig}
        onSelectOrganization={handleSelectOrganization}
        onSelectLocation={handleSelectLocation}
        onSelectPractitioner={handleSelectPractitioner}
      />
    </section>
  )
}
export default PractitionerRoleDetail